<script>
import { onMount } from 'svelte'
import { createEventDispatcher } from 'svelte';
import { input_disabled_dialogue, base_asset_path } from './stores.js';
import { createAudioMeter } from './volume-meter.js';
import TestSpeechInputArea from  "./components/SpeechInputAreas/TestSpeechInputArea.svelte";
import ConversationManager from "./ConversationManager/conversationManager.js"
import ReChat from "./ReChat.svelte"
import {matchDistanceForSpeechTest} from "./match_distance_store.js"
import Conversation from './ConversationManager/conversation.js';

const dispatch = createEventDispatcher();
export let focusTrap;
let conversationName = "speechTest";
let listening;
let speechTestCardPath = $base_asset_path+"speech_test/speech_test.rechat.json";
const instructionDefaultPhrase = "Please press the microphone and say:"
let loadReChatSpeechTest;
let speechTestReChat;
let speechAllowed;
let microphoneExists;
let feedback = "";
let instructions = "";
let testLine = "";
let stream = null;
let indicateRestart = false;
let audioContext = null;
let mediaStreamSource = null;
let meter = null;
let meterObject = null;
let volumeMod = 0;
let rafID = null;
let currentTextInput;
let distanceForSpeechTest = $matchDistanceForSpeechTest;
let reChatFinishedMounting = false;
let speechInputArea;
let conversationManager = new ConversationManager();
let playingSuccess;

let matchInput = (input,allowPartialMatch) => {
  let result = conversationManager.matchInput(input,allowPartialMatch);
  processMatchResult(result);
  return result;
}

function processMatchResult(result)
{
  if(result == Conversation.matchReturnValues.noMatchFound)
  {
    
    feedback = "We couldn't understand what you said.  Try speaking more clearly, and checking your microphone level in your computer settings.";
    setTimeout(function(){
      feedback = "";
    }, 5000)
  }
  else if(result == Conversation.matchReturnValues.matchFound)
  {
    feedback = "";
    speechRecognized();
    if(conversationManager.checkConversationState(conversationName) == conversationManager.conversation_state.ended)
    {
      setTimeout(function(){
        speechInputArea.enableMicClicks();
        indicateRestart = true;
        instructions = "Speech recognition is working fully";
      }, 1950);  
    }
    else
    {
      setTimeout(function(){
        speechInputArea.enableMicClicks();
        speechInputArea.micReset();
        instructions = "Now try saying:";
      }, 1950);  
    }
  } 
  else
  {
    feedback = "";
  }
}

function goBack()
{
  if(mediaStreamSource)
    mediaStreamSource.disconnect();
  if(meter)
    meter.shutdown();
  if(audioContext)
    audioContext.close();
  if(stream)
  {
    stream.getTracks().forEach(function(track) {
      track.stop();
    });
  }
  window.cancelAnimationFrame( rafID );
  dispatch('speechTest');    
}

$:{
  if(reChatFinishedMounting)
    conversationManager.matchInput("start_speech_test",false);
}

async function restartSpeechTest()
{
  instructions = instructionDefaultPhrase;
  await loadReChatSpeechTest();
  conversationManager.matchInput("start_speech_test",false);
}

function speechRecognized() {
  speechInputArea.playMicSuccess()
  speechInputArea.disableMicClicks();
  instructions = "Speech accepted"
}

navigator.mediaDevices.getUserMedia({ audio: {autoGainControl: false} })
  .then(audioStream => {
    stream = audioStream;
    audioContext = new AudioContext();

    mediaStreamSource = audioContext.createMediaStreamSource(stream);
    meter = createAudioMeter(audioContext);
    mediaStreamSource.connect(meter);
    
    drawLoop();
  })
  .catch(function(err){
    console.log("The following error occured: " + err.name)
});

function drawLoop( time )
{ 
  volumeMod = meter.volume > 0.01 ? meter.volume * 1.10 : meter.volume;
  volumeMod = meterRounding(volumeMod*750*2, 30);
  if(meterObject != null)
    meterObject.style.width = volumeMod;

  // set up the next visual callback
  rafID = window.requestAnimationFrame( drawLoop );
}

function meterRounding(value, multiplier)
{
  value = parseFloat(value);
  return(Math.round(value / multiplier) * multiplier);
}



onMount( async function() {    
  conversationManager.addConversation(conversationName,[{person:"tutorial",rechat:speechTestReChat,noSelfMatch:true}],0,false);
  window.AudioContext = window.AudioContext || window.webkitAudioContext;
  await navigator.permissions.query({ name: 'microphone' }).then(function(permissionStatus){
    if(permissionStatus.state === "granted")
    {
        speechAllowed = true;
        microphoneExists = true;
        instructions = instructionDefaultPhrase;
    }
    else
    {
      speechInputArea.micError();
      instructions = "Please provide permission in your browser";
      speechAllowed = false;        
    }

    permissionStatus.onchange = function(){
        if(this.state === "granted")
        {
            speechAllowed = true;
            microphoneExists = true;
            instructions = instructionDefaultPhrase;
        }
        else
        {
          speechInputArea.micError();
          instructions = "Please provide permission in your browser";
          speechAllowed = false;
        }
    }  
  })
  await navigator.mediaDevices.enumerateDevices().then(function(devices) {
    devices.forEach(function(device) {
      console.log(device.kind + ": " + device.label +
              " id = " + device.deviceId);
    });
  })
  navigator.mediaDevices.ondevicechange = function(event) {
    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      microphoneExists = true;
      instructions = instructionDefaultPhrase;
      speechInputArea.micReset();
    }).catch(error => {
      microphoneExists = false;
      speechInputArea.micError();
      instructions = "No microphone detected";
    })
  }
  speechAllowed = true;
});

</script>

<style lang="less">
.viewportRatio(@x, @y)
{
  width: 100vw;
  height: @y * 100vw / @x;
  //max-width: @x / @y * 100vh;
  max-height: 100vh;
}

.speechMenu
{
  overflow: auto;
  display: flex;
  flex-direction: column;
  
}

.testContainer
{
  min-height: -webkit-min-content;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.speechTopBar
{
  height: 20%;
  min-height: 100px;
  width: 100%;
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background: #ededed;
  text-align: center;
}
.back-button {
    height: 8vw;
    width: 8vw;
    margin-left: 5%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}
.back-button-circle {
    width: 100%;
    height: 100%;
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    background: #023b5a;
    box-shadow: 0 0 3px grey;
}
.back-button-circle:hover {
  background:#30588e;
  cursor:pointer;
}
.back-button label {
    position: absolute;
    left: 10%;
    width: 80%;
    height: 85%;
    top: 55%;
    color: #e2eaf3;
    font-family: Verdana;
    font-size: 1.5vw;
    font-weight: bold;
    text-decoration: none;
    pointer-events: none;
}
.backIcon
{
    position: absolute;
    left: 10%;
    width: 80%;
    height: 80%;
    fill: #e2eaf3;
}

@-o-keyframes woong {
  0% {
    -webkit-trasform: scale(1.2);
  }
  50% {
    -webkit-transform: scale(1.8);
    opacity: 0.5;
  }
  100% {
    -webkit-transform: scale(2.4);
    opacity: 0;
  }
}
@-webkit-keyframes woong {
  0% {
    -webkit-trasform: scale(1.2);
  }
  50% {
    -webkit-transform: scale(1.8);
    opacity: 0.5;
  }
  100% {
    -webkit-transform: scale(2.4);
    opacity: 0;
  }
}
@-moz-keyframes woong {
  0% {
    -webkit-trasform: scale(1.2);
  }
  50% {
    -webkit-transform: scale(1.8);
    opacity: 0.5;
  }
  100% {
    -webkit-transform: scale(2.4);
    opacity: 0;
  }
}
@keyframes woong {
  0% {
    -webkit-trasform: scale(1.2);
  }
  50% {
    -webkit-transform: scale(1.8);
    opacity: 0.5;
  }
  100% {
    -webkit-transform: scale(2.4);
    opacity: 0;
  }
}
#testCommandDiv
{
  height: 10%;
  width: 75%;
  margin: 0 auto;
  display: flex;
  align-items: flex-end;
  padding-bottom: 1%;
}
#testLineDiv
{
  height: 15%;
  width: 70%;
  display: flex;
  align-items: center;
  margin: 0 auto;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes scale {
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}

@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 10vw #023b5a;
  }
}
.topBarParagraph
{
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    color: #023b5a;
    font-size: 3vw;
    pointer-events: none;
}
.testDiv
{
    flex: 5;
    display: flex;
    flex-direction: column;
    overflow: auto;
    position: relative;
    height: 80%;
    width: 100%;
}
#testCommand
{
    font-size: 1.5vw;
    color: #023b5a;
    display: inline-block;
    margin: 0 auto;
}
#testLine
{
    font-size: 1.75vw;
    color: #023b5a;
    font-weight: bold;
    display: inline-block;
    margin: 0 auto;
    text-align: center;
}

#srTextDiv
{
  height: 10%;
  width: 65%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
#srFeedbackDiv
{
  height: 10%;
  width: 80%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
#srHelpDiv
{
  height: 10%;
  width: 56%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
#speechRecognitionFeedback
{
  font-size: 1.35vw;
  color: #023b5a;
  font-weight: bold;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
}

#speechRecognitionText
{
    font-size: 1.25vw;
    color: #023b5a;
    display: inline-block;
    margin: 0 auto;
    text-align: center;
}

.backBtn
{
    background: transparent;
    border: none !important;
    font-size: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    padding: 1px 0px;
    border-radius: 50%;
    cursor: pointer;
    right: 0vw;
    bottom: 0vw;
    pointer-events: none;
}

.backBtn:focus > .btn_content
{
  box-shadow: 0 0 0 3px #fff, 0 0 0 5px #023b5a;
  outline: none; // removes default focus outline
}

.back-button-circle:focus-within {
    box-shadow: 0 0 0 3px #fff, 0 0 0 5px #023b5a;
    outline: none; // removes default focus outline
  }

.back-button-circle:focus,
.btn_content:focus
{
  outline: none;
}
  .btn_content
{
  display: inline-block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  pointer-events: all;
}
#volume_meterDiv
{
    height: 10%;
    width: 20%;
    margin: 0 auto;
    display: flex;
    align-items: center;
}

.speechActive
{
  width: 100vh;
  color: #023b5a;
  font-weight: bold;
  display: inline-block;
  margin: 0 auto;
}

.speechInactive
{
  width: 100vh;
  color:  #99B0BD;
  font-weight: bold;
  display: inline-block;
  margin: 0 auto;
}

#meter
{
  border: 2px solid black;
  position: relative;
  margin: 0 auto;
  display: block;
}

#myMask > .cls-2
{
  stroke: none;
}

@media (max-width: 800px)
{
  .back-button
  {
    height: 65px;
    width: 65px;
  }
  .back-button label
    {
      font-size: 75%;
    }
}
@media (max-height: 600px) and (min-width: 801px)
{
  .topBarParagraph
  { 
    font-size: 225%
  }
  .back-button
  {
    height: 70px;
    width: 70px;
  }
  .back-button label
  {
    font-size: 80%;
  }
  #testCommandDiv
  {
    height: 12%;
  }


}
  @media all and (max-aspect-ratio: ~"3/2") and (min-width: 801px)
  {
    .back-button
    {
      height: 8vw;
      width: 8vw;
    }
    .back-button label
    {
      font-size: 1.5vw;
    }
  }
  @media all and (max-aspect-ratio: ~"3/2")
  {
    .speechMenu {
      .viewportRatio(4,3);
      top:0;bottom:0; /* vertical center */
      left:0;right:0; /* horizontal center */      
    }
    #testCommand
    {
      font-size: 1.5vw;
    }
    #testLine
    {
      font-size: 1.75vw;
    }
    #speechRecognitionText
    {
      font-size: 1.25vw;
    }
    #speechRecognitionFeedback
    {
      font-size: 1.35vw;
    }
    #speechRecognitionHelp
    {
      font-size: 1vw;
    }
    .topBarParagraph
    {
      font-size: 3vw;
    }

  }

  @media all and (min-aspect-ratio: ~"3/2")
  {
    .speechMenu {
      .viewportRatio(16,9);
      top:0;bottom:0; /* vertical center */
      left:0;right:0; /* horizontal center */      
    }
  }
  @media all and (min-aspect-ratio: ~"3/2") and (min-height: 601px)
  {
    .back-button
    {
      height: 12vh;
      width: 12vh;
    }
    .topBarParagraph
    {
      font-size: 6vh;
     }
     .back-button label
    {
      font-size: 2vh;
    }
  }
</style>

<div class="speechMenu">        
  <div class="speechTopBar">
    <div class="back-button">
      <div class="back-button-circle">
        <svg class="backIcon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="transform: scale(-1)"><path fill="none" d="M0 0h24v24H0z"/><path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z"/></svg>
        <button class="backBtn" on:click={goBack} aria-label="Back"><span class="btn_content" tabindex="-1" aria-hidden="true"></span></button>
        <label>BACK</label>
      </div>
    </div>
    <p class="topBarParagraph" data-cy="micPageTitle">VERIFY SPEECH RECOGNITION SETUP</p>
  </div>
  <div class="testDiv">
    <div class="testContainer">
      <div id="testCommandDiv">
        <p id="testCommand" aria-live="polite" aria-atomic="true" tabindex="1">{@html instructions}</p>
      </div>
      {#if speechAllowed && microphoneExists}
      <div id="testLineDiv">
        <p id="testLine" aria-live="polite" aria-atomic="true" tabindex="2">{testLine&&!playingSuccess?testLine:""}</p>
      </div>
      {/if}
      <TestSpeechInputArea bind:this={speechInputArea} bind:focusTrap bind:currentTextInput bind:matchInput bind:listening bind:indicateRestart on:restartSpeechTest={restartSpeechTest} bind:speechAllowed bind:microphoneExists bind:playingSuccess />

      {#if speechAllowed && microphoneExists}
      <div id="volume_meterDiv">
        <svg id="volume_meter" class:speechInactive={!listening} class:speechActive={listening} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 839 78">
          <defs>
            {#if !listening}
              <style>.cls-1{fill:#99B0BD;}.cls-2{fill:#fff;}.cls-3{fill:none;stroke:#99B0BD;stroke-miterlimit:10;stroke-width:3;}</style>
            {:else}
              <style>.cls-1{fill:#023b5a;}.cls-2{fill:#fff;}.cls-3{fill:none;stroke:#023b5a;stroke-miterlimit:10;stroke-width:3;}</style>
            {/if}
          </defs>
          <g id="Rectangle_Fill" data-name="Rectangle Fill">
            <rect bind:this={meterObject} class="cls-1" x="75" width="0" height="78" mask="url(#myMask)"/>
          </g>
          <g id="Mask">
            <mask id="myMask">
              <path d="M0,0V78H839V0ZM37,7.5A9.5,9.5,0,0,1,46.5,17c0,.34,0,20.67,0,21a9.5,9.5,0,0,1-18.92-.17c0-.27,0-20.55,0-20.82A9.5,9.5,0,0,1,37,7.5ZM52.88,51C48.75,55.5,42.5,58.5,40.5,58.5v13h-7v-13c-2,0-8.25-3-12.38-7.51S14.5,40.5,14.5,38.5h7c0,5,7.46,14.28,15,14H38c7.37-.13,14.5-9.11,14.5-14h7C59.5,40.5,57,46.49,52.88,51Zm51.57,12a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C104.5,17.34,104.48,62.67,104.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C134.5,17.34,134.48,62.67,134.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C164.5,17.34,164.48,62.67,164.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C194.5,17.34,194.48,62.67,194.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C224.5,17.34,224.48,62.67,224.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C254.5,17.34,254.48,62.67,254.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C284.5,17.34,284.48,62.67,284.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C314.5,17.34,314.48,62.67,314.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C344.5,17.34,344.48,62.67,344.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C374.5,17.34,374.48,62.67,374.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C404.5,17.34,404.48,62.67,404.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C434.5,17.34,434.48,62.67,434.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C464.5,17.34,464.48,62.67,464.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C494.5,17.34,494.48,62.67,494.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C524.5,17.34,524.48,62.67,524.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C554.5,17.34,554.48,62.67,554.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C584.5,17.34,584.48,62.67,584.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C614.5,17.34,614.48,62.67,614.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C644.5,17.34,644.48,62.67,644.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C674.5,17.34,674.48,62.67,674.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C704.5,17.34,704.48,62.67,704.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C734.5,17.34,734.48,62.67,734.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C764.5,17.34,764.48,62.67,764.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C794.5,17.34,794.48,62.67,794.45,63Zm30,0a9.5,9.5,0,0,1-18.92-.17c0-.27,0-45.55,0-45.82a9.5,9.5,0,0,1,19,0C824.5,17.34,824.48,62.67,824.45,63Z"/><path class="cls-2" d="M37,46.5A9.51,9.51,0,0,0,46.45,38c0-.32,0-20.65,0-21a9.5,9.5,0,0,0-19,0c0,.27,0,20.55,0,20.82A9.51,9.51,0,0,0,37,46.5Z"/><path class="cls-2" d="M815,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,815,7.5Z"/><path class="cls-2" d="M785,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,785,7.5Z"/><path class="cls-2" d="M755,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,755,7.5Z"/><path class="cls-2" d="M725,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,725,7.5Z"/><path class="cls-2" d="M695,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,695,7.5Z"/><path class="cls-2" d="M665,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,665,7.5Z"/><path class="cls-2" d="M635,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,635,7.5Z"/><path class="cls-2" d="M605,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,605,7.5Z"/><path class="cls-2" d="M575,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,575,7.5Z"/><path class="cls-2" d="M545,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,545,7.5Z"/><path class="cls-2" d="M515,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,515,7.5Z"/><path class="cls-2" d="M485,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,485,7.5Z"/><path class="cls-2" d="M455,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,455,7.5Z"/><path class="cls-2" d="M425,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,425,7.5Z"/><path class="cls-2" d="M395,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,395,7.5Z"/><path class="cls-2" d="M365,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,365,7.5Z"/><path class="cls-2" d="M335,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,335,7.5Z"/><path class="cls-2" d="M305,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,305,7.5Z"/><path class="cls-2" d="M275,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,275,7.5Z"/><path class="cls-2" d="M245,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,245,7.5Z"/><path class="cls-2" d="M215,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,215,7.5Z"/><path class="cls-2" d="M185,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,185,7.5Z"/><path class="cls-2" d="M155,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,155,7.5Z"/><path class="cls-2" d="M125,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,125,7.5Z"/><path class="cls-2" d="M95,7.5A9.5,9.5,0,0,0,85.5,17c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,95,7.5Z"/><path class="cls-2" d="M38,52.5H36.5c-7.54.28-15-9-15-14h-7c0,2,2.5,8,6.62,12.49S31.5,58.5,33.5,58.5v13h7v-13c2,0,8.25-3,12.38-7.51S59.5,40.5,59.5,38.5h-7C52.5,43.39,45.37,52.37,38,52.5Z"/>
            </mask>
          </g>
          <g id="ShowLayer">
            <path class="cls-3" d="M37,46.5A9.51,9.51,0,0,0,46.45,38c0-.32,0-20.65,0-21a9.5,9.5,0,0,0-19,0c0,.27,0,20.55,0,20.82A9.51,9.51,0,0,0,37,46.5Z"/><path class="cls-3" d="M815,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,815,7.5Z"/><path class="cls-3" d="M785,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,785,7.5Z"/><path class="cls-3" d="M755,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,755,7.5Z"/><path class="cls-3" d="M725,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,725,7.5Z"/><path class="cls-3" d="M695,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,695,7.5Z"/><path class="cls-3" d="M665,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,665,7.5Z"/><path class="cls-3" d="M635,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,635,7.5Z"/><path class="cls-3" d="M605,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,605,7.5Z"/><path class="cls-3" d="M575,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,575,7.5Z"/><path class="cls-3" d="M545,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,545,7.5Z"/><path class="cls-3" d="M515,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,515,7.5Z"/><path class="cls-3" d="M485,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,485,7.5Z"/><path class="cls-3" d="M455,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,455,7.5Z"/><path class="cls-3" d="M425,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,425,7.5Z"/><path class="cls-3" d="M395,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,395,7.5Z"/><path class="cls-3" d="M365,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,365,7.5Z"/><path class="cls-3" d="M335,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,335,7.5Z"/><path class="cls-3" d="M305,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,305,7.5Z"/><path class="cls-3" d="M275,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,275,7.5Z"/><path class="cls-3" d="M245,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,245,7.5Z"/><path class="cls-3" d="M215,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,215,7.5Z"/><path class="cls-3" d="M185,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,185,7.5Z"/><path class="cls-3" d="M155,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,155,7.5Z"/><path class="cls-3" d="M125,7.5a9.5,9.5,0,0,0-9.5,9.5c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32.05-45.65.05-46A9.5,9.5,0,0,0,125,7.5Z"/><path class="cls-3" d="M95,7.5A9.5,9.5,0,0,0,85.5,17c0,.27,0,45.55,0,45.82a9.5,9.5,0,0,0,18.92.17c0-.32,0-45.65,0-46A9.5,9.5,0,0,0,95,7.5Z"/><path class="cls-3" d="M38,52.5H36.5c-7.54.28-15-9-15-14h-7c0,2,2.5,8,6.62,12.49S31.5,58.5,33.5,58.5v13h7v-13c2,0,8.25-3,12.38-7.51S59.5,40.5,59.5,38.5h-7C52.5,43.39,45.37,52.37,38,52.5Z"/>
          </g>
        </svg>
      </div>
      <div id="srTextDiv">
        <p id="speechRecognitionText">{currentTextInput}</p>
      </div>
      <div id="srFeedbackDiv">
        <p id="speechRecognitionFeedback" aria-live="polite" aria-atomic="true">{feedback}</p>
      </div>
      <div id="srHelpDiv">
        <p id="speechRecognitionHelp">If you are having trouble with speech recognition check your operating system microphone level settings and make sure when you speak, the level is neither too low nor too high.  It should be in the middle of the display on average.</p>
      </div>
    {/if}
    </div>
  </div>
</div>

<ReChat bind:this={speechTestReChat} bind:finishedMounting={reChatFinishedMounting} bind:dialogue={testLine} restoreState={false} person="speechTest" bind:matchDistance={distanceForSpeechTest} bind:cardsFilePath={speechTestCardPath} bind:loadReChat={loadReChatSpeechTest}/>
